import { SelectOption } from 'tailwindComponents/selectTW/interfaces';
import { ICorrectionReason } from 'types/corrections/ICorrection';
import { labelComparator } from '../../utilities/labelComparator';

export interface ISigningTypeResponse {
  id: string;
  label: string;
  description?: string;
}

export const getSigningTypeOptions = (signingTypes: ISigningTypeResponse[]): SelectOption[] =>
  signingTypes
    .map((type: ISigningTypeResponse) => ({
      label: type.label,
      value: type.id,
    }))
    .toSorted(labelComparator);

export const getCorrectionReasons = (correctionReasons: ICorrectionReason[]): SelectOption[] =>
  correctionReasons.map((correction: ICorrectionReason) => ({
    label: correction.label,
    value: correction.id,
  }));

export const REFINANCE_FAXES_SIGNING_TYPE_NAME = 'refinance-faxes';
export const LENDER_BUYER_ONLY_WITH_FAXES_SIGNING_TYPE_NAME = 'lender-buyer-faxes';
export const LENDER_SELLER_ONLY_WITH_FAXES_SIGNING_TYPE_NAME = 'lender-seller-faxes';
